import { AlertOctagon, ChevronsUpIcon } from "lucide-react";
import { Focusable } from "react-aria-components";

import { Tooltip, TooltipTrigger } from "@/components/ui/tooltip";

export function ActiveHoldIndicator() {
  return (
    <TooltipTrigger delay={500}>
      <Focusable>
        <AlertOctagon className="text-red-600 size-4 shrink-0" tabIndex={-1} />
      </Focusable>
      <Tooltip>Active hold</Tooltip>
    </TooltipTrigger>
  );
}

export function StatIndicator() {
  return (
    <TooltipTrigger delay={500}>
      <Focusable>
        <ChevronsUpIcon
          className="text-orange-600 size-4 shrink-0"
          tabIndex={-1}
        />
      </Focusable>
      <Tooltip>STAT</Tooltip>
    </TooltipTrigger>
  );
}
